import { REGISTER, REGISTER_ERROR, REGISTER_LOADING } from "./constants";

export function register(data, cbSuccess){
    return {
        type: REGISTER,
        data,
        cbSuccess,
    }
}
export function setRegisterError(registerError){
    return {
        type: REGISTER_ERROR,
        registerError,
    }
}
export function setRegisterLoading(isLoading){
    return {
        type: REGISTER_LOADING,
        isLoading,
    }
}